import {Pipe, PipeTransform} from '@angular/core';
import {Column, TableService} from 'app/shared/service/table.service';

/**
 * Renvoie le champ d'un élément sous forme de booléen.
 */
@Pipe({name: 'elementFieldAsBoolean'})
export class ElementFieldBooleanPipe implements PipeTransform {

    constructor(public tableService: TableService) {
    }

    transform(element: any, column: Column): boolean | null {
        return this.tableService.getFieldValueAsBoolean(element, column);
    }
}
